
        import 'Spinner.b501c5b.css-module'
        export default {"Modal":"Modal_Spinner_b501c5b","Spinner":"Spinner_Spinner_b501c5b"}
    